import { IdelinkModuleTheme } from '../../../configs/IdeLinkTheme';
import iconBlack from '../assets/ic_pin_codes_black.svg';

export const PinCodesTheme: IdelinkModuleTheme = {
    backgroundColor: '#348ee8',
    permissionIcon: iconBlack,
    permissionSelectedIcon: iconBlack,
    navbarIcon: iconBlack,
};
